import React from "react";
import { useTemplateSetting } from "../../../hooks/useCompanySettings";
import { TOOL_TEMPLATE } from "../../../constant/common";
import QuadrataAverageBasedCalculatorForm from "./templates/QuadrataAverageBasedCalculatorForm";
import VictorAverageBasedCalculatorForm from "./templates/VictorAverageBasedCalculatorForm";

const AverageBasedCalculatorForm = ({
    formState,
    onSubmit,
    loading,
    currencyCode,
    companySettings,
}) => {
    const template = useTemplateSetting();

    switch (template) {
        case TOOL_TEMPLATE.quadrata:
            return (
                <QuadrataAverageBasedCalculatorForm
                    formState={formState}
                    onSubmit={onSubmit}
                    loading={loading}
                    currencyCode={currencyCode}
                    companySettings={companySettings}
                />
            );
        case TOOL_TEMPLATE.victor:
            return (
                <VictorAverageBasedCalculatorForm
                    formState={formState}
                    onSubmit={onSubmit}
                    loading={loading}
                    currencyCode={currencyCode}
                    companySettings={companySettings}
                />
            );
        default:
            return null;
    }
};

export default AverageBasedCalculatorForm;

